import { useEffect } from "react";
import { useHotkeys, type Options } from "react-hotkeys-hook";
import { registerHotkey, unregisterHotkey } from "@/lib/hotkey-registry";

export function useHotkey(
  keys: string,
  callback: () => void,
  options: Options & { description: string }
): void {
  const { description, ...hotkeyOptions } = options;

  useEffect(() => {
    registerHotkey(keys, description);
    return () => unregisterHotkey(keys);
  }, [keys, description]);

  useHotkeys(keys, callback, hotkeyOptions);
}
